// This file contains additional logic/functions used by the boxcaster controller in association
// with an EDID for parsing supported resolutions, but is BoxCast-specific (hence why it is not
// part of edid.js).

const BC_525P_30  = {height:  480, width:  720, progressive: true,  framerate: 30, displayFramerate: "29.97/30"};
const BC_525P_60  = {height:  480, width:  720, progressive: true,  framerate: 60, displayFramerate: "59.94/60"};
const BC_625P_25  = {height:  576, width:  720, progressive: true,  framerate: 25, displayFramerate: "25"};
const BC_625P_50  = {height:  576, width:  720, progressive: true,  framerate: 50, displayFramerate: "50"};
const BC_720P_24  = {height:  720, width: 1280, progressive: true,  framerate: 24, displayFramerate: "23.98/24"};
const BC_720P_25  = {height:  720, width: 1280, progressive: true,  framerate: 25, displayFramerate: "25"};
const BC_720P_30  = {height:  720, width: 1280, progressive: true,  framerate: 30, displayFramerate: "29.97/30"};
// TODO: No idea what the HFP for 720p48 is...
const BC_720P_50  = {height:  720, width: 1280, progressive: true,  framerate: 50, displayFramerate: "50"};
const BC_720P_60  = {height:  720, width: 1280, progressive: true,  framerate: 60, displayFramerate: "59.94/60"};
const BC_1080I_48 = {height: 1080, width: 1920, progressive: false, framerate: 48, displayFramerate: "48"};
const BC_1080I_50 = {height: 1080, width: 1920, progressive: false, framerate: 50, displayFramerate: "50"};
const BC_1080I_60 = {height: 1080, width: 1920, progressive: false, framerate: 60, displayFramerate: "59.94/60"};
const BC_1080P_24 = {height: 1080, width: 1920, progressive: true,  framerate: 24, displayFramerate: "23.98/24"};
const BC_1080P_25 = {height: 1080, width: 1920, progressive: true,  framerate: 25, displayFramerate: "25"};
const BC_1080P_30 = {height: 1080, width: 1920, progressive: true,  framerate: 30, displayFramerate: "29.97/30"};
const BC_1080P_48 = {height: 1080, width: 1920, progressive: true,  framerate: 48, displayFramerate: "48"};
const BC_1080P_50 = {height: 1080, width: 1920, progressive: true,  framerate: 50, displayFramerate: "50"};
const BC_1080P_60 = {height: 1080, width: 1920, progressive: true,  framerate: 60, displayFramerate: "59.94/60"};
const BC_2160P_24 = {height: 2160, width: 3840, progressive: true,  framerate: 24, displayFramerate: "23.98/24"};
const BC_2160P_25 = {height: 2160, width: 3840, progressive: true,  framerate: 25, displayFramerate: "25"};
const BC_2160P_30 = {height: 2160, width: 3840, progressive: true,  framerate: 30, displayFramerate: "29.97/30"};
const BC_2160P_48 = {height: 2160, width: 3840, progressive: true,  framerate: 48, displayFramerate: "48"};
const BC_2160P_50 = {height: 2160, width: 3840, progressive: true,  framerate: 50, displayFramerate: "50"};
const BC_2160P_60 = {height: 2160, width: 3840, progressive: true,  framerate: 60, displayFramerate: "59.94/60"};

function dtdToBoxCastResolution(dtd) {
  if (dtd.interlaced) {
    if ((dtd.horActivePixels === 1920) && (dtd.vertActivePixels === 540) && (dtd.pixelClock === 74.25)) {
      switch (dtd.horSyncOff) {
        case 638:
          return BC_1080I_48;
          break;

        case 528:
          return BC_1080I_50;
          break;

        case 88:
          return BC_1080I_60;
          break;
      }
    }
  } else {
    if ((dtd.horActivePixels === 3840) && (dtd.vertActivePixels === 2160) && (dtd.pixelClock === 594)) {
      switch (dtd.horSyncOff) {
        case 1276:
          return BC_2160P_48;
          break;

        case 1056:
          return BC_2160P_50;
          break;

        case 176:
          return BC_2160P_60;
          break;
      }
    } else if ((dtd.horActivePixels === 3840) && (dtd.vertActivePixels === 2160) && (dtd.pixelClock === 297)) {
      switch (dtd.horSyncOff) {
        case 1276:
          return BC_2160P_24;
          break;

        case 1056:
          return BC_2160P_25;
          break;

        case 176:
          return BC_2160P_30;
          break;
      }
    } else if ((dtd.horActivePixels === 1920) && (dtd.vertActivePixels === 1080) && (dtd.pixelClock === 148.5)) {
      switch (dtd.horSyncOff) {
        case 638:
          return BC_1080P_48;
          break;

        case 528:
          return BC_1080P_50;
          break;

        case 88:
          return BC_1080P_60;
          break;
      }
    } else if ((dtd.horActivePixels === 1920) && (dtd.vertActivePixels === 1080) && (dtd.pixelClock === 74.25)) {
      switch (dtd.horSyncOff) {
        case 638:
          return BC_1080P_24;
          break;

        case 528:
          return BC_1080P_25;
          break;

        case 88:
          return BC_1080P_30;
          break;
      }
    } else if ((dtd.horActivePixels === 1280) && (dtd.vertActivePixels === 720) && (dtd.pixelClock === 74.25)) {
      switch (dtd.horSyncOff) {
        // TODO: No idea what the HFP for 720p48 is...
        case 440:
          return BC_720P_50;
          break;

        case 110:
          return BC_720P_60;
          break;
      }
    } else if ((dtd.horActivePixels === 1280) && (dtd.vertActivePixels === 720) && (dtd.pixelClock === 37.125)) {
      switch (dtd.horSyncOff) {
        // TODO: No idea what the HFP for 720p24 is...
        case 440:
          return BC_720P_25;
          break;

        case 110:
          return BC_720P_30;
          break;
      }
    } else if ((dtd.horActivePixels === 720) && (dtd.vertActivePixels === 576) && (dtd.pixelClock === 27)) {
      return BC_625P_50;
    } else if ((dtd.horActivePixels === 720) && (dtd.vertActivePixels === 576) && (dtd.pixelClock === 13.5)) {
      return BC_625P_25;
    } else if ((dtd.horActivePixels === 720) && (dtd.vertActivePixels === 480) && (dtd.pixelClock === 27)) {
      return BC_525P_60;
    } else if ((dtd.horActivePixels === 720) && (dtd.vertActivePixels === 480) && (dtd.pixelClock === 13.5)) {
      return BC_525P_30;
    }
  }
  return null;
};

function vicToBoxCastResolution(vic) {
  switch (vic) {
    case 2: // fall through
    case 3:
      return BC_525P_60;
      break;

    case 17: // fall through
    case 18:
      return BC_625P_50;
      break;

    case 60: // fall through
    case 65:
      return BC_720P_24;
      break;

    case 61: // fall through
    case 66:
      return BC_720P_25;
      break;

    case 62: // fall through
    case 67:
      return BC_720P_30;
      break;

    case 19: // fall through
    case 68:
      return BC_720P_50;
      break;

    case 4: // fall through
    case 69:
      return BC_720P_60;
      break;

    case 20:
      return BC_1080I_50;
      break;

    case 5:
      return BC_1080I_60;
      break;

    case 32: // fall through
    case 72:
      return BC_1080P_24;
      break;

    case 33: // fall through
    case 73:
      return BC_1080P_25;
      break;

    case 34: // fall through
    case 74:
      return BC_1080P_30;
      break;

    case 31: // fall through
    case 75:
      return BC_1080P_50;
      break;

    case 16: // fall through
    case 76:
      return BC_1080P_60;
      break;

    case 93: // fall through
    case 103:
      return BC_2160P_24;
      break;

    case 94: // fall through
    case 104:
      return BC_2160P_25;
      break;

    case 95: // fall through
    case 105:
      return BC_2160P_30;
      break;

    case 96: // fall through
    case 106:
      return BC_2160P_50;
      break;

    case 97: // fall through
    case 107:
      return BC_2160P_60;
      break;
  }
};

export function ParseSupportedBoxCastResolutions(edid) {
  var supportedBoxCastResolutions = [];
  const f = dtd => {
    var bcr = dtdToBoxCastResolution(dtd);
    if (bcr && !_.contains(supportedBoxCastResolutions, bcr)) {
      supportedBoxCastResolutions.push(bcr);
    }
  };
  if (edid.dtds) _.each(edid.dtds, f);
  if (edid.exts) {
    _.each(edid.exts, ext => {
      if (ext.dtds) _.each(ext.dtds, f);
      if (ext.dataBlockCollection) {
        _.each(ext.dataBlockCollection, dataBlock => {
          if (dataBlock.tag && dataBlock.tag.string && (dataBlock.tag.string == "VIDEO") && dataBlock.shortVideoDescriptors) {
            _.each(dataBlock.shortVideoDescriptors, descriptor => {
              var bcr = vicToBoxCastResolution(descriptor.vic);
              if (bcr && !_.contains(supportedBoxCastResolutions, bcr)) {
                supportedBoxCastResolutions.push(bcr);
              }
            });
          }
        });
      }
    });
  }
  return supportedBoxCastResolutions.sort((a, b) => {
    // first sort by height, highest to lowest
    if (a.height < b.height) {
      return 1;
    } else if (b.height < a.height) {
      return -1;
    }

    // next, width, highest to lowest
    if (a.width < b.width) {
      return 1;
    } else if (b.width < a.width) {
      return -1;
    }

    // Next, progressive before interlaced
    if (!a.progressive && b.progressive) {
      return 1;
    } else if (a.progressive && !b.progressive) {
      return -1;
    }

    // Next, framerate, highest to lowest
    if (a.framerate < b.framerate) {
      return 1;
    } else if (b.framerate < a.framerate) {
      return -1;
    }

    return 0;
  });
}



// WEBPACK FOOTER //
// ./utils/boxcast-edid.js